import axios from 'axios';

// Using global axios.defaults.baseURL set in index.jsx

class UserAgreementService {
  static async getPendingAgreements() {
    try {
      const response = await axios.get(`/user/agreements/pending`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching pending agreements:', error);
      throw error;
    }
  }

  static async acceptAgreements(agreements, triggerContext = {}) {
    try {
      const response = await axios.post(`/user/agreements/bulk-accept`, {
        agreements,
        triggerContext
      }, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error accepting agreements:', error);
      throw error;
    }
  }

  static async checkUserCompliance(userId) {
    try {
      const response = await axios.get(`/user/compliance/user/${userId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error checking compliance:', error);
      throw error;
    }
  }

  static async getRequiredDocuments(trigger, userType) {
  try {
    const response = await axios.get(`/front/documents/required`, {
      params: { trigger, userType },
      header: {}
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching required documents:', error);
    throw error;
  }
}

}

export default UserAgreementService;
